import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'; // 👈 Importar esto
import { ReactiveFormsModule } from '@angular/forms'; // ✅ Agregar esto
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { UserModule } from './modules/user/user.module';
import { PeriodsModule } from './modules/periods/periods.module';
import { ExpenseReportsModule } from './modules/expense-reports/expense-reports.module';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ComissionsModule } from './modules/comissions/comissions.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './modules/auth/interceptors/token.interceptor';

// Registrar el idioma español
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    UserModule,
    PeriodsModule,
    ExpenseReportsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxPaginationModule,    
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
